/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsBCSQuestion {
    getFixupPrototypeFunction() { return AppSecopsBCSQuestion.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsBCSQuestion>): AppSecopsBCSQuestion {
        let obj = Object.assign(new AppSecopsBCSQuestion(), model);
        AppSecopsBCSQuestion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsBCSQuestion>): AppSecopsBCSQuestion {
        if (!model) return null;
        return AppSecopsBCSQuestion.newInstance(<AppSecopsBCSQuestion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsBCSQuestion) {
        if (!obj) return;

        models.AppSecopsBCSQuestion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsBCSQuestion): boolean {
        Object.setPrototypeOf(obj, AppSecopsBCSQuestion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.order === undefined) {
            this.order = 0;
        }
        if (this.default_weight === undefined) {
            this.default_weight = 0;
        }
        if (this.weight === undefined) {
            this.weight = 0;
        }
        if (this.options) {
            for (let val of this.options) {
                models.AppSecopsBCSQuestionOption.fixupPrototype(val);
            }
        }
    }

    /**
     * Question ID
     */
    id: string;

    /**
     * Display order
     */
    order: number;

    /**
     * Short title
     */
    title: string;

    /**
     * Full question text
     */
    question: string;

    /**
     * Additional info
     */
    description: string;

    options: Array<models.AppSecopsBCSQuestionOption>;

    /**
     * Default weight
     */
    default_weight: number;

    /**
     * Effective weight (tenant override of default_weight)
     */
    weight: number;

    /**
     * Whether this question allows multiple option selections (Q6)
     */
    multi_select: boolean;

    /**
     * Whether lower answer value means higher criticality (Q9, Q10)
     */
    inverted: boolean;

}
